import { Mutator } from 'final-form';

import { OAuthConnectionFieldsType } from '../../../api/configurations/oauth2connection/types';

export const addScope: Mutator<OAuthConnectionFieldsType> = (_, state, utils) => {
  utils.changeValue(state, 'scope', (prev) => ['', ...prev]);
};

export const deleteScope: Mutator<OAuthConnectionFieldsType> = (args, state, utils) => {
  const [orderNumber] = args;
  utils.changeValue(state, 'scope', (prev) => {
    return prev.filter((_: string, index: number) => index !== orderNumber);
  });
};

export const touchLogoUrl: Mutator<OAuthConnectionFieldsType> = (_, state, utils) => {
  const field = state.fields.logo_url;

  if (field) {
    field.touched = true;
  }
};

export const changeLogoUrl: Mutator<OAuthConnectionFieldsType> = ([newLogoValue], state, utils) => {
  const field = state.fields.logo_url;
  field.touched = true;

  utils.changeValue(state, 'logo_url', () => newLogoValue);
};

export const changeBackgroundColor: Mutator<OAuthConnectionFieldsType> = (
  [newColorValue],
  state,
  utils
) => {
  utils.changeValue(state, 'background_color', () => newColorValue);
};
